import { KYMW1002Model } from '../kymw1002.model';
import { Injectable, inject } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { CommonSettingModel } from '../vo/common-setting.model';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { CommonSetting } from 'src/app/commons/kymw00/common-setting';
import { map } from 'rxjs/operators';

/**
 * AppRoutingModuleで使用するリゾルバ.
 * 
 * @param route 
 * @param state 
 * @returns 
 */
export const commonSettingResolver: ResolveFn<boolean> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const getCommonSettingService = inject(GetCommonSettingService);
  return getCommonSettingService.send$('KYMW02getCommonSetting', new PlessRequest())
    .pipe(map(res => true));
}

/**
 * 環境設定(SETTING)を取得するサービス
 *
 * @export GetCommonSettingService
 * @class GetCommonSetting
 * @extends {PlessResponder}
 */
@Injectable()
export class GetCommonSettingService extends PlessJsonResponderSub<CommonSettingModel[]> {

  // 処理に使用するModel
  private model: KYMW1002Model = null;
  private successFunc: (obj: CommonSettingModel[]) => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetCommonSettingService
   */
  execute(model: KYMW1002Model, successFunc: (obj: CommonSettingModel[]) => void): void {
    this.model = model;
    this.successFunc = successFunc;
    this.send('KYMW02getCommonSetting', new PlessRequest());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCommonSettingService
   */
  success(data: CommonSettingModel[]): void {
    CommonSetting.init(data);
  }

  /**
   * API通信失敗時の処理
   *
   * @param {string} status エラーステータス
   * @param {*} result エラー結果
   * @memberof GetCommonSettingService
   */
  exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
